import * as _ from 'lodash'
import { GetterTree } from 'vuex'
import { I18nState } from '@/modules/i18n/store'
import { RootState } from '@/store/types'
import Locale from '@/modules/i18n/model/Locale'
import WorldLocale from '@/modules/i18n/model/WorldLocale'
import Message from '@/modules/i18n/model/Message'
import MessageTranslation from '@/modules/i18n/model/MessageTranslation';

const getters: GetterTree<I18nState, RootState> = {

    /**
     * Localismos simple ISO 639
     *
     * Existen localismo cuyo identificador esta compuesto por lenguaje_variante_region,
     * este getter los obvia y solo obtiene los localismos recogidos por ISO 639-1.
     */
    simpleLocaleNames: (state): WorldLocale[] => {
        return state.worldLocales.filter(value => (value.identifier.match(/_/g) || []).length <= 1)
    },

    /**
     * Nombre un localismo del mundo en base a su identificador
     */
    worldLocaleName: (state, getters) => (identifier: Locale | string): string => {
        identifier = typeof identifier === 'string' ? identifier : identifier.identifier
        return _.result(
            _.find(getters.simpleLocaleNames, l => l.identifier === identifier),
            'name', '',
        )
    },

    /**
     * Localismo registrado en el estado
     */
    locale: (state) => (identifier: string): Locale | undefined => {
        return _.find(state.locales, locale => locale.identifier === identifier)
    },

    /**
     * Busca y obtiene el mensaje con la clave argumentada en el localismo
     * dado.
     */
    localeMessage: (state, getters) => (locale: string, key: string): Message | null => {
        const messages: Message[] = getters.localeMessages(locale)
        if (!messages) {
            return null
        }

        return messages.find(message => message.key === key) || null
    },

    /**
     * Localismo actual
     *
     * Permite obtener el localismo que actualmente seleccionado por el usuario en
     * la lista de traducciones
     */
    currentLocale: (state): Locale | null => {
        const identifier = state.messageList.selectedLocale
        if (!identifier) {
            return null
        }

        return state.locales.find(l => l.identifier === identifier) || null
    },

    localeExists: (state, getters) => (identifider: string): boolean => !!getters.locale(identifider),

    /**
     * Traducción actual del mensaje actualmente seleccionado
     */
    currentMessageTranslation: (state) => (locale: string = '') => {
        const message = state.messageList.selectedMessage
        locale  = locale || state.messageList.selectedLocale
        if (!message) {
            throw new Error('No existe ningún mensaje seleccionado')
        }

        return message.translate(locale) || new MessageTranslation(0, locale)
    },
}

export default getters
